export default function priceToMillion(price) {
	return `€ ${(Number(price).toFixed(1))}`;
}